"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationServiceProvider = exports.NotificationServiceContext = void 0;
var react_1 = __importDefault(require("react"));
var Notification_1 = __importDefault(require("components/core/Notification"));
exports.NotificationServiceContext = react_1.default.createContext(null);
exports.NotificationServiceProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.default.useState(null), notificationState = _b[0], setNotificationState = _b[1];
    var _c = react_1.default.useState(false), visible = _c[0], setVisible = _c[1];
    var _d = react_1.default.useState(null), timer = _d[0], setTimer = _d[1];
    var openNotification = function (options) {
        setNotificationState(options);
        setVisible(true);
        clearTimeout(timer);
        setTimer(setTimeout(function () {
            setVisible(false);
            setTimeout(function () {
                setNotificationState(null);
            }, 300);
        }, options.timeout || 4000));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.NotificationServiceContext.Provider, { value: openNotification, children: children }),
        react_1.default.createElement(Notification_1.default, __assign({ visible: Boolean(visible) }, notificationState))));
};
